// relative to webapp
export const SYNC_STORAGE_KEY = "synchronization"
export const WEBAPP_SYNC_SOURCE = "@lockself_sync_webapp"
export const WEBAPP_SYNC_TYPE = "@lockself_sync"

// relative to Extension
export const EXTENSION_SYNC_SOURCE = "@lockself_sync_extension"
export const EXTENSION_SYNC_TYPE = "@lockself_sync_update"

// relative to first sso connection data (webapp -> extension)
export const WEBAPP_SYNC_FIRST_CONNECTION_SSO_TYPE =
	"@lockself_v3_sync_webapp_first_connection_sso"
export const FIRST_CONNECTION_SSO_DATA =
	"@lockself_v3_sso_first_connection_data"

export const V4_PAYLOAD_KEYS = [
	"v4MfaToken",
	"v4SessionToken",
	"decryptedPrivateKey",
	"ssoToken",
	"sessionDuration",
	"v4FirstSsoConnectionData",
	"v4OrganizationOptions",
]
